const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Organizer',
        dataIndex: 'organizer',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
];

export default columns;